@if (!loading) {
<div class="box">
  <div class="page-header">
    <div>
      <p class="page-title">Applications</p>
      <p class="page-desc">Review and approve all registered D-PUSH applications. Approved applications can start sending push notifications to their users.</p>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon stat-icon--total">
        <mat-icon>apps</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ applicationsCount }}</span>
        <span class="stat-label">Total</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon stat-icon--active">
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ activeApplications }}</span>
        <span class="stat-label">Active</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon stat-icon--pending">
        <mat-icon>schedule</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ awaitingApplications }}</span>
        <span class="stat-label">Awaiting</span>
      </div>
    </div>
  </div>

  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search applications…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="row-icon"><mat-icon>dns</mat-icon></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="application_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Application Name</th>
        <td mat-cell *matCellDef="let element">{{ element.application_name }}</td>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
      </ng-container>

      <ng-container matColumnDef="approved">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">
          @if (element.approved) {
            <span class="status-badge status-badge--approved">
              <mat-icon>check_circle</mat-icon> Approved
            </span>
          } @else {
            <span class="status-badge status-badge--pending">
              <mat-icon>schedule</mat-icon> Awaiting
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(element, 'Edit', true, true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="5">
          <div class="empty-state">
            <mat-icon>inbox</mat-icon>
            <p>No applications found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(row, 'Edit', true, true)"></tr>
    </table>
  </div>

  <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25]"
    showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
} @else {
  <app-loading-spinner></app-loading-spinner>
}
